import jsBridge from './utils/bridge.mjs';
import { API_AUTHORIZE, API_GET_AUTH } from './utils/constant.mjs';
export var Scope;
(function (Scope) {
    Scope["Record"] = "record";
    Scope["Camera"] = "camera";
    Scope["Media"] = "media";
})(Scope || (Scope = {}));
/**
 * 授权
 */
export function authorize(params) {
    if (!params || !params.scope) {
        throw new Error('scope参数不能为空');
    }
    return jsBridge.callPromise({
        minVersion: '1.1.3'
    }, API_AUTHORIZE, params);
}
/**
 * 获取权限设置
 */
export function getAuth(params = {}) {
    return jsBridge.callPromise({
        minVersion: '1.1.3'
    }, API_GET_AUTH, params);
}
